import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u82F1\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import { onMounted, onBeforeUnmount, ref, reactive, watch, nextTick } from "vue";
import { enGetJobsDetail_url, enSaveJobsApplication_url } from '@/api'; //引入发送请求获取数据的方法

import { useRouter, useRoute } from "vue-router";
import { ElMessage } from 'element-plus';
import Join from "@/pages/contactUs/components/join.vue";
export default {
  components: {},
  name: "Job",
  setup: function setup() {
    var jobDetail = ref({});
    var fileList = ref([]);
    var formRef = ref(null);
    var uploadRef = ref(null);
    var router = useRouter();
    var route = useRoute();
    var messageForm = reactive({
      name: "",
      phone: "",
      email: ""
    });
    var rules = reactive({
      name: [{
        required: true,
        message: "Please enter your name",
        trigger: "blur"
      }],
      phone: [{
        required: true,
        message: "Please enter your phone number",
        trigger: "blur"
      }, {
        pattern: /^1[3456789]\d{9}$/,
        message: "Please enter a phone number in the correct format"
      }],
      email: [{
        required: true,
        message: "Please enter your email address",
        trigger: "blur"
      }]
    });
    var upLoadBtn = ref(null);
    var loading = ref(false);

    var submitForm = function submitForm(formRef) {
      if (!formRef) return;
      formRef.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 8;
                    break;
                  }

                  if (!(fileList.value.length == 0)) {
                    _context.next = 4;
                    break;
                  }

                  ElMessage('Please select resume attachment');
                  return _context.abrupt("return");

                case 4:
                  loading.value = true; // 调用上传组件，在成功的钩子函数处理后续逻辑

                  uploadRef.value.submit();
                  _context.next = 8;
                  break;

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }; // 上传组件钩子函数


    var successFun = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
        var params, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(res.code === 200)) {
                  _context2.next = 6;
                  break;
                }

                // console.log('成功进入');
                params = {
                  jobId: route.query.jobId,
                  applicantName: messageForm.name,
                  applicantPhone: messageForm.phone,
                  applicantEmail: messageForm.email,
                  resumeUrl: res.url
                };
                _context2.next = 4;
                return enSaveJobsApplication_url(params);

              case 4:
                result = _context2.sent;

                // console.log(result,'看看结果');
                if (result.code === 200) {
                  ElMessage('success');
                  loading.value = false;
                  router.push({
                    path: '/contact'
                  });
                } else {
                  ElMessage('fail');
                  loading.value = false;
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function successFun(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    var getJobsDetail = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var jobId, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                jobId = route.query.jobId;
                _context3.next = 3;
                return enGetJobsDetail_url({
                  jobId: jobId
                });

              case 3:
                res = _context3.sent;
                jobDetail.value = res.data.jobsDetail;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getJobsDetail() {
        return _ref3.apply(this, arguments);
      };
    }();

    onMounted(function () {
      getJobsDetail();
    });

    var upNotesClk = function upNotesClk() {
      upLoadBtn.value.$el.click(); // console.log(upLoadBtn)
    };

    var handleChange = function handleChange(file, fileList) {// console.log(file, fileList, "这是获取的文件列表")
    };

    return {
      messageForm: messageForm,
      rules: rules,
      upNotesClk: upNotesClk,
      handleChange: handleChange,
      jobDetail: jobDetail,
      upLoadBtn: upLoadBtn,
      fileList: fileList,
      submitForm: submitForm,
      formRef: formRef,
      loading: loading,
      uploadRef: uploadRef,
      successFun: successFun
    };
  }
};